import { useMemo } from 'react';

import { logger } from 'shared/infrastructure/logger';

type UseNutrientLicenceKeyParams = {
  isEnabled: boolean;
  licence: string | undefined;
};

/** Clave de Nutrient Standalone para el host actual: `''` sin licencia y `undefined` si no es JSON. */
export default function useNutrientLicenceKey({ isEnabled, licence }: UseNutrientLicenceKeyParams): string | undefined {
  // Memoizado: con una licencia que no es JSON, parsear en cada render mandaría un aviso a Sentry por render.
  return useMemo(() => {
    if (!isEnabled) return undefined;
    if (!licence) return '';
    try {
      const licenceByHost: Record<string, string> = JSON.parse(licence);
      return licenceByHost[globalThis.location.host];
    } catch {
      // Sin el error: el mensaje de JSON.parse puede citar parte de la licencia.
      logger.warn('Viewer: nutrient_licence is not valid JSON');
      return undefined;
    }
  }, [isEnabled, licence]);
}
